<template>
  <v-card class="settings-section-card">
    <v-card-title class="pb-1 section-header product-card-title">
      <div class="section-header__text">
        <span class="section-header__accent"></span>
        <span>{{ title }}</span>
        <span v-if="subtitle" class="section-header__subtitle">{{
          subtitle
        }}</span>
      </div>
      <v-spacer />
      <slot name="actions" />
    </v-card-title>
    <v-divider class="my-0" />
    <v-card-text :class="bodyClass">
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SettingsSectionCard",
  props: {
    icon: {
      type: String,
      default: "fal fa-cog",
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    accent: {
      type: Boolean,
      default: false,
    },
    bodyClass: {
      type: String,
      default: "pa-4",
    },
  },
};
</script>

<style scoped>
/* Matches the PosSmart v2 product card style (products/card.vue): white
   surface, slate-200 border, 16px radius, no elevation shadow. */
.settings-section-card.v-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: none !important;
}

.settings-section-card.v-card.theme--light {
  background: #fff;
  border: 1px solid #e2e8f0;
}

.settings-section-card.v-card.theme--dark {
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.section-header {
  position: relative;
  padding: 14px 20px 14px 16px;
}

/* Title row: matches manage/add-product.vue's .ap-card-title +
   .product-card-title (bold 14px title, inline accent bar + subtitle). */
.product-card-title {
  font-size: 14px;
  font-weight: 500;
}

.section-header__text {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

.section-header__accent {
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: var(--v-primary-base, #5b39c9);
  display: inline-block;
  flex-shrink: 0;
}

.section-header__subtitle {
  font-size: 11.5px;
  font-weight: 400;
  color: #94a3b8;
}

/* Section Card Input Fields Appearance */
.settings-section-card ::v-deep .v-text-field--outlined .v-input__slot,
.settings-section-card ::v-deep .v-textarea--outlined .v-input__slot {
  background: #f8fafc !important;
  border-radius: 12px !important;
  min-height: 44px;
  border: 1px solid #e2e8f0 !important;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.settings-section-card ::v-deep .v-text-field--outlined fieldset,
.settings-section-card ::v-deep .v-textarea--outlined fieldset {
  border: none !important;
}

.settings-section-card ::v-deep .v-text-field--outlined.v-input--is-focused .v-input__slot,
.settings-section-card ::v-deep .v-textarea--outlined.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
  border-color: var(--v-primary-base, #5b39c9) !important;
  box-shadow: 0 0 0 3px rgba(91, 57, 201, 0.12) !important;
}

.settings-section-card ::v-deep .v-text-field--outlined .v-input__slot input,
.settings-section-card ::v-deep .v-select__selection,
.settings-section-card ::v-deep .v-textarea--outlined .v-input__slot textarea {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.settings-section-card ::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  align-self: center !important;
}

.settings-section-card ::v-deep .ps-text-field > .pb-2,
.settings-section-card ::v-deep .ps-text-select > .pb-2,
.settings-section-card ::v-deep .ps-text-area > .pb-2 {
  font-size: 13.5px !important;
  font-weight: 700 !important;
  color: #1e293b !important;
  margin-bottom: 6px;
}

::v-deep .theme--dark.settings-section-card .v-text-field--outlined .v-input__slot,
::v-deep .theme--dark.settings-section-card .v-textarea--outlined .v-input__slot {
  background: #262638 !important;
  border-color: rgba(255, 255, 255, 0.12) !important;
}

::v-deep .theme--dark.settings-section-card .v-text-field--outlined.v-input--is-focused .v-input__slot,
::v-deep .theme--dark.settings-section-card .v-textarea--outlined.v-input--is-focused .v-input__slot {
  background: #262638 !important;
  border-color: #8b6ff0 !important;
  box-shadow: 0 0 0 3px rgba(139, 111, 240, 0.2) !important;
}

::v-deep .theme--dark.settings-section-card .v-text-field--outlined .v-input__slot input,
::v-deep .theme--dark.settings-section-card .v-select__selection,
::v-deep .theme--dark.settings-section-card .v-textarea--outlined .v-input__slot textarea {
  color: #f1f5f9 !important;
}

::v-deep .theme--dark.settings-section-card .ps-text-field > .pb-2,
::v-deep .theme--dark.settings-section-card .ps-text-select > .pb-2,
::v-deep .theme--dark.settings-section-card .ps-text-area > .pb-2 {
  color: rgba(255, 255, 255, 0.88) !important;
}
</style>
